<!--
@Time : 2020/12/24 11:37 上午
@Author : yekong
@File : left.vue
@Software : PhpStorm
-->
<template>
  <div class="bodycenter">
    <div class="x1" :style="{height:height+'px'}">
      <item class="xs" title="热门停车场动态">
        <vtable></vtable>
      </item>
    </div>
  </div>
</template>

<script>
import item from "_c/home/item";
import vtable from "_c/home/center/vtable";
import $ from 'jquery'

export default {
  name: "left",
  components: {item, vtable},
  data: function () {
    return {
      show: true,
      height: 0
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  mounted() {
    window.addEventListener('resize', this.reload)
    this.reload()
  },
  filters: {},
  methods: {
    reload() {
      this.height = $('.bodyleft').height() * 0.3;
    }
  },
}
</script>

<style lang="scss" scoped>
.x1 {
  position: relative;
  width: 100%;
  height: 100%;

}

.bodycenter {
  width: 40%;
  position: absolute;
  left: 30%;
  height: calc(38% - 1rem - 1.85%);
  bottom: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: column;

}

</style>
<style lang="scss">
.xs {
  width: 100%;
  .bodyitembody{
    width: 100% !important;
    padding: 3% 0 !important;
    .tablehead{
      background: rgba(53, 92, 128, 1.00);
    }
  }
}
</style>
